import { RMA_TYPE } from 'b2b-apps/shop/myAccount/rma/utils/rma';
import { RmaDetailedType, RmaInvoiceType, UpdateRmaBodyType } from 'b2b-common/core/account/api/rma';
import {
  CANCEL_RMA,
  CANCEL_RMA_FULFILLED,
  CANCEL_RMA_REJECTED,
  CLEAR_ACCOUNT_RMA,
  CLEAR_RMA_CANCEL,
  CLEAR_RMA_CREATE,
  CLEAR_RMA_INVOICES,
  CLEAR_RMA_SEND_EMAIL,
  CLEAR_RMA_UPDATE,
  CREATE_RMA,
  CREATE_RMA_FULFILLED,
  CREATE_RMA_REJECTED,
  FETCH_RMA,
  FETCH_RMA_FULFILLED,
  FETCH_RMA_INVOICE,
  FETCH_RMA_INVOICE_FULFILLED,
  FETCH_RMA_INVOICE_REJECTED,
  FETCH_RMA_REJECTED,
  SEND_RMA_EMAIL,
  SEND_RMA_EMAIL_FULFILLED,
  SEND_RMA_EMAIL_REJECTED,
  UPDATE_RMA,
  UPDATE_RMA_FULFILLED,
  UPDATE_RMA_REJECTED,
} from './actionTypes';
import {
  CancelRmaAction,
  CancelRmaFulfilledAction,
  CancelRmaRejectedAction,
  ClearAccountRmaAction,
  ClearRmaCancelAction,
  ClearRmaCreateAction,
  ClearRmaInvoicesAction,
  ClearRmaSendEmailAction,
  ClearRmaUpdateAction,
  CreateRmaAction,
  CreateRmaFulfilledAction,
  CreateRmaRejectedAction,
  FetchRmaAction,
  FetchRmaFulfilledAction,
  FetchRmaInvoiceAction,
  FetchRmaInvoiceFulfilledAction,
  FetchRmaInvoiceRejectedAction,
  FetchRmaRejectedAction,
  SendRmaEmailAction,
  SendRmaEmailFulfilledAction,
  SendRmaEmailRejectedAction,
  UpdateRmaAction,
  UpdateRmaFulfilledAction,
  UpdateRmaRejectedAction,
} from './types';

const createRma = <T>(
  type: RMA_TYPE,
  data: T,
  isStandalone = false,
): CreateRmaAction<T> => ({
    type: CREATE_RMA,
    payload: {
      data,
      type,
      isStandalone,
    },
  });

const createRmaFulfilled = (): CreateRmaFulfilledAction => ({
  type: CREATE_RMA_FULFILLED,
});

const createRmaRejected = (error: ErrorType): CreateRmaRejectedAction => ({
  type: CREATE_RMA_REJECTED,
  payload: {
    error,
  },
});

const fetchRma = (rmaId: string, debitorId?: string): FetchRmaAction => ({
  type: FETCH_RMA,
  payload: {
    rmaId,
    debitorId,
  },
});

const fetchRmaFulfilled = (rmaId: string, response: RmaDetailedType): FetchRmaFulfilledAction => ({
  type: FETCH_RMA_FULFILLED,
  payload: {
    rmaId,
    data: response,
  },
});

const fetchRmaRejected = (rmaId: string, error: ErrorType): FetchRmaRejectedAction => ({
  type: FETCH_RMA_REJECTED,
  payload: {
    rmaId,
    error,
  },
});

const sendRmaEmail = (debitorId: string, rmaId: string, email: string): SendRmaEmailAction => ({
  type: SEND_RMA_EMAIL,
  payload: {
    debitorId,
    rmaId,
    email,
  },
});

const sendRmaEmailFulfilled = (): SendRmaEmailFulfilledAction => ({
  type: SEND_RMA_EMAIL_FULFILLED,
});

const sendRmaEmailRejected = (rmaId: string, error: ErrorType): SendRmaEmailRejectedAction => ({
  type: SEND_RMA_EMAIL_REJECTED,
  payload: {
    rmaId,
    error,
  },
});

const fetchRmaInvoice = (rmaInvoiceId: string, debitorId?: string): FetchRmaInvoiceAction => ({
  type: FETCH_RMA_INVOICE,
  payload: {
    rmaInvoiceId,
    debitorId,
  },
});

const fetchRmaInvoiceFulfilled = (rmaInvoiceId: string, response: RmaInvoiceType): FetchRmaInvoiceFulfilledAction => ({
  type: FETCH_RMA_INVOICE_FULFILLED,
  payload: {
    rmaInvoiceId,
    data: response,
  },
});

const fetchRmaInvoiceRejected = (rmaInvoiceId: string, error: ErrorType): FetchRmaInvoiceRejectedAction => ({
  type: FETCH_RMA_INVOICE_REJECTED,
  payload: {
    rmaInvoiceId,
    error,
  },
});

const updateRma = (rmaId: string, data: UpdateRmaBodyType): UpdateRmaAction => ({
  type: UPDATE_RMA,
  payload: {
    rmaId,
    data,
  },
});

const updateRmaFulfilled = (): UpdateRmaFulfilledAction => ({
  type: UPDATE_RMA_FULFILLED,
});

const updateRmaRejected = (rmaId: string, error: ErrorType): UpdateRmaRejectedAction => ({
  type: UPDATE_RMA_REJECTED,
  payload: {
    rmaId,
    error,
  },
});

const cancelRma = (rmaId: string): CancelRmaAction => ({
  type: CANCEL_RMA,
  payload: {
    rmaId,
  },
});

const cancelRmaFulfilled = (): CancelRmaFulfilledAction => ({
  type: CANCEL_RMA_FULFILLED,
});

const cancelRmaRejected = (rmaId: string, error: ErrorType): CancelRmaRejectedAction => ({
  type: CANCEL_RMA_REJECTED,
  payload: {
    rmaId,
    error,
  },
});

const clearAccountRma = (): ClearAccountRmaAction => ({
  type: CLEAR_ACCOUNT_RMA,
});

const clearRmaCancel = (): ClearRmaCancelAction => ({
  type: CLEAR_RMA_CANCEL,
});

const clearRmaSendEmail = (): ClearRmaSendEmailAction => ({
  type: CLEAR_RMA_SEND_EMAIL,
});

const clearRmaCreate = (): ClearRmaCreateAction => ({
  type: CLEAR_RMA_CREATE,
});

const clearRmaInvoices = (): ClearRmaInvoicesAction => ({
  type: CLEAR_RMA_INVOICES,
});

const clearRmaUpdate = (): ClearRmaUpdateAction => ({
  type: CLEAR_RMA_UPDATE,
});

export {
  cancelRma,
  cancelRmaFulfilled,
  cancelRmaRejected,
  clearAccountRma,
  clearRmaCancel,
  clearRmaCreate,
  clearRmaInvoices,
  clearRmaSendEmail,
  clearRmaUpdate,
  createRma,
  createRmaFulfilled,
  createRmaRejected,
  fetchRma,
  fetchRmaFulfilled,
  fetchRmaInvoice,
  fetchRmaInvoiceFulfilled,
  fetchRmaInvoiceRejected,
  fetchRmaRejected,
  sendRmaEmail,
  sendRmaEmailFulfilled,
  sendRmaEmailRejected,
  updateRma,
  updateRmaFulfilled,
  updateRmaRejected,
};
